import { isMyIpResourceActive } from './resourceSlots';
import type { MyIpItem, MyIpResource } from './types';

/** 画布 IP card 更多素材多选上限（用例：最多 47）。 */
export const MY_IP_MAX_CANVAS_MATERIAL_SELECTION = 47;

/** 单个 IP 更多素材存储上限（用例：上限 100）。 */
export const MY_IP_MAX_MATERIALS = 100;

/** 计入更多素材配额的资源角色：附图与视频，不含主视觉/三视图/音色。 */
const MORE_MATERIAL_ROLES = new Set(['additional_image', 'video']);

/** 更多素材超过存储上限；调用方转成可见 toast，不暴露内部文案。 */
export class MyIpMaterialLimitError extends Error {
  /**
   * @param message - 仅诊断用，界面文案由宿主提供
   */
  constructor(message = 'IP material limit reached') {
    super(message);
    this.name = 'MyIpMaterialLimitError';
  }
}

/**
 * 判断资源是否占用「更多素材」配额。
 * @param resource - IP 资源关系
 */
export function isMyIpMoreMaterialResource(resource: Pick<MyIpResource, 'role' | 'status'>): boolean {
  return MORE_MATERIAL_ROLES.has(resource.role) && isMyIpResourceActive(resource);
}

/**
 * 统计当前 IP 已占用的更多素材数量。
 * @param item - 已鉴权 IP 主档
 */
export function countMyIpMoreMaterials(item: Pick<MyIpItem, 'resources'>): number {
  return item.resources.filter(isMyIpMoreMaterialResource).length;
}

/**
 * 校验再写入若干新更多素材后是否仍未超上限。
 * @param item - 当前主档
 * @param incomingNewCount - 本次净新增条数（已存在同键更新计 0）
 */
export function canAcceptMyIpMoreMaterials(
  item: Pick<MyIpItem, 'resources'>,
  incomingNewCount: number,
): boolean {
  if (!Number.isInteger(incomingNewCount) || incomingNewCount < 0) return false;
  return countMyIpMoreMaterials(item) + incomingNewCount <= MY_IP_MAX_MATERIALS;
}
